import React, {useState, useEffect} from "react";
import { Row, Col, Modal, Card } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/css/bootstrap.css';
import '../components/custom.css';


export const Suites = (props) => {
  
  const [isOpen, setisOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [showModal, setShowModal] = useState(false); // State to actually render the modal
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showModal5, setShowModal5] = useState(false);
  const [showModal6, setShowModal6] = useState(false);
  

  useEffect(() => {
    console.log('Modal isOpen state changed:', isOpen);

    if (isOpen) {
      // Introduce a slight delay before showing the modal
      const timer = setTimeout(() => setShowModal(true), 100); // 100ms delay
      return () => clearTimeout(timer); // Clean up the timer
    }
    else {
      setShowModal(false)// Immediately hide modal when `isOpen` is false
    }

    if (isOpen1) {
      const timer = setTimeout(() => setShowModal1(true), 100); // 100ms delay
      return () => clearTimeout(timer); // Clean up the timer
    }else{
      setShowModal1(false)
    }

    if (isOpen2) {
      const timer = setTimeout(() => setShowModal2(true), 100); // 100ms delay
      return () => clearTimeout(timer); // Clean up the timer
    }else{
      setShowModal2(false)
    }

    if (isOpen3) {
      const timer = setTimeout(() => setShowModal3(true), 100); // 100ms delay
      return () => clearTimeout(timer); // Clean up the timer
    }else{
      setShowModal3(false)
    }

    if (isOpen4) {
      const timer = setTimeout(() => setShowModal4(true), 100); // 100ms delay
      return () => clearTimeout(timer); // Clean up the timer
    }else{
      setShowModal4(false)
    }

    if (isOpen5) {
      const timer = setTimeout(() => setShowModal5(true), 100); // 100ms delay
      return () => clearTimeout(timer); // Clean up the timer
    }else{
      setShowModal5(false)
    }
    if (isOpen6) {
      const timer = setTimeout(() => setShowModal6(true), 100); // 100ms delay
      return () => clearTimeout(timer); // Clean up the timer
    }else{
      setShowModal6(false)
    }
  },[isOpen, isOpen1, isOpen2, isOpen3, isOpen4, isOpen5, isOpen6]);
  
  const handleLinkClick = (link) => {

    // console.log("Link clicked:", link);

    if (link === 'general') {
      setisOpen(true);
    } else if (link === 'individual') {
      setIsOpen1(true); 
    }else if (link === 'grouplife') {
      setIsOpen2(true);
    }else if(link === 'financial'){
      setIsOpen3(true);
    }else if(link === 'sacco'){
      setIsOpen4(true);
    }else if(link === 'hr'){
      setIsOpen5(true);
    }
    else if(link === 'pension'){
      setIsOpen6(true);
    }

    console.log('Modal isOpen state:', isOpen);
    // Add more conditions for other links if needed
  };

  return (

    /** general modal **/

    <React.Fragment>
    <div id="suites">
      <div className="container">
        <div className="section-title text-center">
          <h2>Insync Product Suite</h2>
          <h4>Business Suite.</h4>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      {" "}
                      {/* <img src={d.img} alt="" />{" "} */}
                      <i className="fa fa-flag"></i>
                    </div>
                    <div className="testimonial-content">
                      
                      <p className="text-title" dangerouslySetInnerHTML={{ __html: d.text }} onClick={(e) => {
                        const clickedElement = e.target;

                        console.log("Clicked Element:", clickedElement);
                        console.log("Clicked Element Tag Name:", clickedElement.tagName);
console.log("Clicked Element href:", clickedElement.getAttribute("href"));

                        if (clickedElement.tagName === "A") {
                          e.preventDefault();  // Prevent default anchor behavior (navigation)
                          const link = clickedElement.getAttribute("href");
                          handleLinkClick(link);  // Trigger modal based on link
                        }
                      }}></p>
                      
                      <div className="testimonial-meta"> {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
        {/* <button onClick={() => setisOpen(true)}>Open Modal</button> */}
      </div>
    </div>
    <Modal
    className="custom-modal"
        size="xl"
        show={showModal}
        onHide={() => {
          setisOpen(false);
        }}
        backdrop="static"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          display: 'block', /* Ensure it's visible */
          visibility: 'visible', /* Force visibility */
          opacity: "1"
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h6">General Insurance</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pagelblue">
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
              Line of Business
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Insync General Insurance supports all classes of businesses in the industry such as Fire and Perils, Burglary, Motor, Goods in Transit, WIBA, Public Liability, Engineering, Personal/ Group Personal Accident, Marine, Fidelity Guarantee, Professional Indemnity, Liability, Travel, Money etc.
              The system also supports combined business arrangements where several classes can be insured as one package under one policy.
              The system is flexible enough to allow defining of new classes or redefining the existing as per requirements of the insurance company.
              Multi-company premium rates, Special client's rates among other rates can be set for sub classes across regions or companies.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
              Quotation Module
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Insync General Insurance allows for generation of quotation internally by underwriters or through the online portal by the prospective client. The online portal
                also caters for Agents to request for quotations for their clients. In the system, quotations are easily converted to policies. The system provides tolling inform
                of reports and views to keep track of quotations which ultimately assists in business statistics.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
             Underwriting
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Insync General Insurance supports both direct and indirect business underwriting processes.
Some of the direct business underwritings include :</p>
<p>
<ol>
<li>New Business </li>                              
<li>Extra Endorsement</li>
<li>Nil Endorsement</li>
<li>Policy Renewals</li>
<li>Motor Certificates</li>
<li>Marine Certificates</li>
<li>Policy Refund</li>
<li>Policy Cancellation</li>
<li>Policy Reinstatement</li>
</ol>
</p>
<p>
The system also supports the following types of business underwritings:
</p>
<p>
  <ol>
  <li>Coinsurance</li>
  <li>Facultative Inwards</li>
  <li>Fronting Types</li>
  </ol>
  </p>
  <p>
During the underwriting process, the system generates relevant charges such as : Stamp duty, training levy, PHCF, Agency commission & W/Tax etc. The system also attaches the default clauses,
generates reinsurance figures and facultative placement for amounts beyond treaties done.
On approval, the system generates the relevant account transaction types(Debit/Credit notes including those of Reinsurance, Agency commission and W/Tax). Accounts GL entries are created and posted into the Accounting system.
Accompanied by approval is the set of report generation that can also be printed :
</p>
<p>
<ol>
<li>Policy Schedules</li>
<li>Underwriting Debit/Credit Notes</li>
<li>Reinsurance Schedules</li>
<li>Reinsurance Debit/Credit Notes</li>
</ol>
              </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Allocation Of Receipts To Debits
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>The system has a very elaborate procedure for matching receipts to debit notes, with the provisions for controlled un-matching. Reports and views exist that can be used for reconciling receipts and debits.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Motor Certificates
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>The Motor Certificates Module is elaborate. It provides for a centralized definition of certificate batches, and the allocation ranges of certificates to different branches and/or intermediaries. Allocation of certificates to risks is controlled by User rights, and practical controls have been put in place to ensure proper utilization of certificates. Printing of certificates can be done locally or remotely. Views and Reports that allow administrators to monitor certificate usage also exist.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Renewal Processing
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>At the beginning of each month, policies that are about to expire in a month, or two months time can be copied into the renewal working area. Renewal notices can be generated and printed with the provision for emailing and SMS configuration.
When a client confirms their interest in renewing of the policy, the renewal process can be done directly through this renewal module. Present renewal discounts are considered.
Reports also exists to assist in monitoring renewed and unrenewed businesses.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Claims Processing
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Insync General Insurance allows for clients to easily file for claims online or through their representatives. The claims processing module is a comprehensive module that allows one to
create new claims. Original estimates are maintained at the instance of claim creation with the provision of updating the claim severally while keeping a record of changes.
The system also allows for appointment of service providers, maintenance of correspondences and logging of legal diary.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Reports
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Various standard underwriting reports exist e.g. Quotations Listing, Production
Reports (Class-wise, Branch-wise, Agent-wise), Premium registers, Renewal
Reports, Claims Reports (notified claims, registered claims, outstanding claims,
paid claims, claims loss ratios by policy, class, client), Reinsurance Reports
(Premium bordereau, claims outstanding and paid bordereau), Motor
certificate monitoring reports, etc.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          </Modal.Body>

      </Modal>

      <Modal
    className="modal"
        size="xl"
        show={showModal1}
        onHide={() => {
          setIsOpen1(false);
        }}
        backdrop="static"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          display: 'block', /* Ensure it's visible */
          visibility: 'visible', /* Force visibility */
          opacity: "1"
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h6">Individual Assurance</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pagelblue">
        <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Setup
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>System provides for setting up of different plans/products, premium rates, agents and
              agency units, interest rates, claim types, reinsurance treaties etc.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Proposal Maintenance
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Creation and maintenance of proposal details, preferred plans,
capturing client details, their beneficiaries, medical requirements, initial deposits, conditions
and clauses, Fund Projections. Conversion from Proposal to Policy.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Premium Payments
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>After receipting in accounts, system supports allocation of receipts to
              respective policies.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Policy Maintenance
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Supports different endorsement types, e.g. additional deposit, change of
              beneficiaries, change of policy details.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Loans Management
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Creation of Policy Loans, approval of loans, Loan recoveries,
              accompanying reports.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Reinsurance Processing
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>System generates Policy reinsurance premiums and reinsurance claim
              recoveries depending on reinsurance setups. Accompanying reinsurance reports exist.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Claims Processing
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>System supports Partial Withdrawals, Full Withdrawals, Maturity,
Surrenders, Death Claims etc. depending on the setups and their application in various plans.
System generates discharge vouchers for accounts settlements.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          </Modal.Body>

      </Modal>
      <Modal
    className="modal"
        size="xl"
        show={showModal2}
        onHide={() => {
          setIsOpen2(false);
        }}
        backdrop="static"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          display: 'block', /* Ensure it's visible */
          visibility: 'visible', /* Force visibility */
          opacity: "1"
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h6">Group Life and Group Credit Assurance</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pagelblue">
        <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Setup
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Flexible setup of Insurance Products, Riders, Tariffs, Benefits.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Quotations
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Projected estimations and variances with benefits and riders. views to keep track of quotations which ultimately assists in business statistics.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Proposals
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Conversion of Quotations to Proposals, with flexibility of changes</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Policy Creation
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Capturing of policy details e.g. clients and members, cover period, age limits,
free cover limits, discounts, riders, expected total premium. Policy approval is done at receipt
of first premium.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Medicals
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>System determined medicals where members' Sum Assureds is beyond Free Cover
              Limits, verifies submitted medical reports by insureds</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Premium Collection
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Supports Cash, Cheque, Spreadsheet uploads, Reconciliations with online
              payment options.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Commission Management
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>System maintains intermediary sub-ledgers, generates basic and
over-ride commissions for intermediaries, calculates taxes, and maintains intermediary
statements.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Renewal Notices
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Towards the close of policy anniversary, the system generates renewal
              notices which can be sent online to clients, or printed.
statements.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Reinsurance Processing
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Flexible treaty setup, linked to different products. The system
              generates reinsurance figures with reports to support.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Claims
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>Processing of Funeral benefits, death claims, disability claims. Generation of Discharge
              Vouchers and Linkage to INSYNC Financials.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Reports
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>The system comes with basic Group Life reports. Customized reports can also be
              developed and included at the request of clients.</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          </Modal.Body>

      </Modal>

      <Modal
    className="modal"
        size="xl"
        show={showModal3}
        onHide={() => {
          setIsOpen3(false);
        }}
        backdrop="static"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          display: 'block', /* Ensure it's visible */
          visibility: 'visible', /* Force visibility */
          opacity: "1"
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h6">Financial Management </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pagelblue">
        <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Insync Accounts
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
                <ol>
                  <li>Integrated General Ledger, Accounts Receivable, Accounts Payable</li>
<li>Receipt Processing (receipt creation, approval, receipt generation, receipting reports)</li>
<li> Payment Processing (payments creation, approval, payment voucher generation, payment reports)</li>
<li> Journal Processing (Capturing of Journal details, approval, reports). Different Journal types are
supported i.e. Normal, Corrective, Reversal.</li>
<li> Purchasing: Creation of Purchase orders, Budgeting</li>
<li> Enhance User privilege setup: Determining the type of transactions that can be raised by each User,
 and approval limits depending on the amounts in each transaction.</li>
<li> Budgets by Accounts, Branches, and Revenue/Cost Centers; Reports on Actual verses Budgets</li>
<li> Unlimited user-definable sub-ledgers: A sub-ledger is created once for each client/service provider. The
created sub-ledger can then be defined within several control accounts.</li>
<li> Trial balance, GL activity, Profit and loss, and Balance sheet reports, among others</li>
<li> Banking module and Bank Reconciliation</li>
</ol>
</p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          
          </Modal.Body>

      </Modal>
      <Modal
    className="modal"
        size="xl"
        show={showModal4}
        onHide={() => {
          setIsOpen4(false);
        }}
        backdrop="static"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          display: 'block', /* Ensure it's visible */
          visibility: 'visible', /* Force visibility */
          opacity: "1"
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h6">Insync Sacco </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pagelblue">
        <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Products
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              System provides Maintenance of different share types.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Members
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Registration, Activation and deactivation of accounts, Creation and Maintenance of
Member Subsidiary Ledger Accounts in Insync Accounts. Maintenance of Member share
Contribution types and Loan types.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Withdrawals
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Member withdrawal and Refund Management.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Loans
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Set up of Loan Types and Interest Types and percentages, Member Loan Application,
specification of collaterals and Guarantors, Authorization and Disbursement, Generation and
Maintenance of Loan Repayment Schedule.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Loan Interest Accruals
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Posting of the same to respective General Ledger and Subsidiary
Ledger accounts.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Payments
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Generation of Deduction advice to employers, capturing of Member Share
Contribution and Loan Repayments, posting to respective General Ledger and Subsidiary
Ledger accounts.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Reports
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Member Share Contribution Statements, Loan Repayment Statements, and various
analytical and accounting reports.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          </Modal.Body>

      </Modal>
      <Modal
    className="modal"
        size="xl"
        show={showModal5}
        onHide={() => {
          setIsOpen5(false);
        }}
        backdrop="static"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          display: 'block', /* Ensure it's visible */
          visibility: 'visible', /* Force visibility */
          opacity: "1"
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h6">Human Resource Management </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pagelblue">
        <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Recruitment Module
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              The public can upload CV details through an online recruitment portal, and
update their profile from time to time. Applicants can also apply for vacant positions. Vacancies are
determined from free slots in the ​ Organization structure ​ maintained within the system. Job applicant
details are also maintained, and the positions the applicants are interested in filling. The system keeps
track of interviews, candidates and interview results. The system generates generic regret letters which
can be sent to unsuccessful candidates, and generic appointment letters modifiable to suit successful
candidates. Job applicant details are automatically transferred to the employee records on hiring.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Task Management and Timetabling
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Service departments receive requests from various staff members.
The head of service department may assign particular tasks to an employee in the department. The
progress made on each task can be registered until its closure. Reports and graphs exist to show
assigned versus done tasks per employee, which could further be used during appraisal.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Online Leave Management
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Members of staff can schedule annual leave days and do online leave
applications. Leave applications are approved online by authorized departmental heads and the HR
department. Members of staff can view their leave details (days brought forward, accrued, taken and
balances). The system comes with several leave reports.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Appraisal and Training
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Takes care of promotions, scheduled and unscheduled appraisals (members of
staff complete appraisal forms online), transfers and disciplinary actions. Salary appraisal is linked to
Payroll. Employees (in conjunction with their supervisors) identify training needs, and create training
schedules. When employees complete particular courses, the respective employees’ profiles can be
updated with such information online.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Online Loan Applications
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Employees can apply for loans online. Approval of loans is done by
authorized staff in the HR department. Generated loan repayment schedules are linked to Payroll.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Staff Medical
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              For Companies doing internal medical fund administration, the system maintains
periodic cover periods, allocated fund amounts, employees and dependants, limits of cover by
categories, and the various cover types (inpatient, outpatient, dental, optical, etc). The system also
captures invoices for the purpose of reimbursing employees as per set percentages and limits.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Store Requisitions
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              The HR system is linked to the Stores and Purchases system. Members of staff can
raise store requisitions online. The raised requisitions are first approved by departmental heads and
authorized stores personnel before issuing can be done from stores. Purchases and Issuing increase
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Staff Retirement
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Captures date and reasons for leaving, notice period to be served, exit
interview (partially filled online by the leaving staff), clearance by the various departmental heads, and
freezing and archiving of records in Payroll.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Unlimited Earning and Deduction Types
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              The client can set up unlimited earning and deduction types,
unlimited loan and loan interest types, unlimited non-cash benefits and percentage of tax for each.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Different Payrolls
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              For senior staff, junior staff and casuals, depending on the client. Can also maintain
payrolls for different companies in the fraternity. Also allows for creation and processing of a
supplementary payroll once the main payroll has been processed. This caters for processing of final
dues, or an extra pay at the end of the year.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Historical Data
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Employee earnings and deductions for previous periods and years are maintained in
the system.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Loan Management
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              The system keeps repayment schedules for all employee loans, and automatically
stops deducting loan amounts once the schedules have been exhausted. The system also allows change
of loan details midstream.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Basic and Statutory Reports
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Pay slips, payroll summary reports, NSSF, Insurance, Individual Pension,
Bank Summary, Bank electronic data, P9,P10, etc.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Audit Trails
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Information on who processed the payroll, who generated payroll reports, and who made
modifications to payroll figures can easily be retrieved from the system.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Integration to Financial Module
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              The system integrates with Insync Financials to facilitate the posting
of payroll financial transactions into the General Ledger. Where a client uses another Accounting
system, we provide scripts to extract payroll info in a Journal Voucher format that the accounting
system would pick.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          </Modal.Body>

      </Modal>
      <Modal
    className="modal"
        size="xl"
        show={showModal6}
        onHide={() => {
          setIsOpen6(false);
        }}
        backdrop="static"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
          display: 'block', /* Ensure it's visible */
          visibility: 'visible', /* Force visibility */
          opacity: "1"
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h6">Pension Fund Administration </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pagelblue">
        <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Setup
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Menu setups, User rights and privileges, Product definitions (system supports
provident and Pension schemes for individual and group/occupational), product features,
retirement ages, Annuity tariffs, tax tables, types of claims and withdrawals and interest
setups.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Interest Processing
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Calculation of interest based on transaction dates. Supports interim
interest amounts using provisional interest rates in the course of the year.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Proposals
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              System provides for setting up of different plans/products, premium rates, agents and
agency units, interest rates, claim types, reinsurance treaties etc.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Policy Maintenance
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Capturing of Client details, member details, and conversion of proposal to
scheme
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Scheme Maintenance
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Creation of schemes, scheme endorsements (e.g. addition of
members, change of beneficiaries, change of scheme details), excel uploads of member and
beneficiary details. The system also supports transfer of members from one scheme to
another.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Premium Collections
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Capturing of member receipts, upload of monthly contribution
schedules (options exist where schedules can be copied from previous periods, or from default
member installments), approval of schedules, allocation of receipts to schedules, distribution
of member amount to normal/registered and extra/unregistered.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Premium Payments
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              System provides for setting up of different plans/products, premium rates, agents and
agency units, interest rates, claim types, reinsurance treaties etc.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Commission Processing
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              System maintains intermediary accounts (linked to General
Ledger), calculates commissions due to intermediaries, generates and posts commissions to
intermediary sub accounts, and maintains intermediary statements.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Claim Processing
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Supports Resignations, Retrenchments, Retirements, Death,
Expatriation, and Withdrawal on medical grounds. Calculation of tax using different tax tables
for each scenario.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Annuities
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Supports fixed and variable annuities, deferred and immediate annuities, annuity
purchase (for internal and external schemes), different annuity payment frequencies (monthly,
quarterly, semi-annually, annually), annuity maintenance (member details, reconciliations,
10suspension and reinstatements), various annuity reports.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Online Portal
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Online viewing of statements and scheme
information, customer relations module that supports online correspondences.
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          <Row>
          <Col sm={3}>
          <Card className="mb-4">
            <Card.Body>
            Reports
              </Card.Body>
              </Card>
          </Col>
          <Col sm={9}>
          <Card className="mb-4">
            <Card.Body>
              <p>
              Various standard reports exist e.g. member statements, commission statements,
withholding tax statements, member certificates. New reports can be developed and added to
flexible reports menus (access to various reports controlled by User rights).
            </p>
              </Card.Body>
              </Card>
          </Col>
          </Row>
          
          </Modal.Body>

      </Modal>
    </React.Fragment>
  );
};
